import { render, staticRenderFns } from "./panel-item.vue?vue&type=template&id=7acf5678&scoped=true&"
import script from "./panel-item.js?vue&type=script&lang=js&"
export * from "./panel-item.js?vue&type=script&lang=js&"
import style0 from "./panel-item.scss?vue&type=style&index=0&id=7acf5678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acf5678",
  null
  
)

component.options.__file = "panel-item.vue"
export default component.exports